import React from 'react';
import Footer from '../components/footer';
import Regions from '../components/regions';
import Wrapper from './wrapper';

export default () => {
    return (
        <Wrapper>
            <Regions />
            <Footer />
        </Wrapper>
    );
}